import {
  getHandoffSurveyPreviousGroupInput,
  getHandoffSurveyPreviousGroupOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/get-handoff-survey-previous-group";
import { unaryRpc } from "@redotech/rpc/definition";

// Handoff twin of rewindHsaGroup: stateless predecessor walk over the
// client-held answer set; the server never persists anything.
export const getHandoffSurveyPreviousGroup = unaryRpc({
  name: "getHandoffSurveyPreviousGroup",
  input: getHandoffSurveyPreviousGroupInput,
  output: getHandoffSurveyPreviousGroupOutput,
});
